import { createContext, useContext, useState } from 'react';
import { TabsProps } from 'antd';
import { Tabs } from '@/shared/ui';
import { InvitationsList } from '@/widgets/invitations-list/InvitationsList';
import { MembersList } from '@/widgets/members-list/MembersList';
import { PlanAndBilling } from '@/widgets/plan-and-billing';
import { OrganizationPublicPage } from './OrganizationPublicPage';

export enum TabKeys {
  PublicPage = 'public-page',
  Members = 'members',
  Invitations = 'invitations',
  Plan = 'plan',
}

type TabsContextType = {
  activeTab: string;
};

const TabsContext = createContext({} as TabsContextType);
export const useTabsContext = () => {
  const context = useContext(TabsContext);
  if (context === undefined) {
    throw new Error('useTabsContext must be used within TabsContext');
  }
  return context;
};

export const OrganizationTabs = () => {
  const [activeTab, setActiveTab] = useState(TabKeys.Members);

  const onTabChange = (activeKey: string) => {
    setActiveTab(activeKey as TabKeys);
  };

  const items: TabsProps['items'] = [
    {
      key: TabKeys.Members,
      label: `Members`,
      children: <MembersList />,
    },
    {
      key: TabKeys.Invitations,
      label: `Invitations`,
      children: <InvitationsList />,
    },
    {
      key: TabKeys.PublicPage,
      label: `Public Page`,
      children: <OrganizationPublicPage />,
    },
    {
      key: TabKeys.Plan,
      label: `Plan & Billing`,
      children: <PlanAndBilling />,
    },
  ];

  return (
    <TabsContext.Provider value={{ activeTab }}>
      <Tabs
        defaultActiveKey={TabKeys.Members}
        items={items}
        onChange={onTabChange}
      />
    </TabsContext.Provider>
  );
};
